import ReferralActionTypes from './types';

const initialState = {
  hasJoined: false,
  isSaving: false,
  joinError: '',
  showToaster: false,
  linkText:
    'मैं आपको WheelsEye GPS उपयोग करने के लिए आमंत्रित कर रहा हूं, जो ट्रक सम्बंधित समस्याओं के समाधान के लिए सबसे अच्छा ऐप है। दिए गए लिंक से एक फॉर्म खुलेगा, वहां पर अपना नाम और नंबर भरें । फॉर्म भरने के बाद WheelsEye की टीम आपसे जल्दी संपर्क करेगी। https://weye.in/web-view/referral/join?r=null',
};

const subscribeReducer = (state: any = initialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case ReferralActionTypes.REFERRAL_JOIN_START:
      return {
        ...state,
        hasJoined: false,
        isSaving: true,
        joinError: '',
      };
    case ReferralActionTypes.REFERRAL_JOIN_SUCCESS:
      return {
        ...state,
        hasJoined: true,
        isSaving: false,
        joinError: '',
      };
    case ReferralActionTypes.REFERRAL_JOIN_FAILURE:
      return {
        ...state,
        hasJoined: false,
        isSaving: false,
        joinError: action.payload,
      };
    case ReferralActionTypes.REFERRAL_LINK_SUCCESS:
      const data = action?.payload?.data?.data || { message: '', link: '' };
      if (!!data?.message && !!data?.link) {
        return {
          ...state,
          linkText: data.message + ' ' + data.link,
        };
      } else {
        return {
          ...state,
          linkText: initialState.linkText,
        };
      }
    case ReferralActionTypes.REFERRAL_LINK_FAILURE:
      return {
        ...state,
        linkText: initialState.linkText,
      };
    case ReferralActionTypes.REFERRAL_TOASTER_SHOW:
      return {
        ...state,
        showToaster: true,
      };
    case ReferralActionTypes.REFERRAL_TOASTER_HIDE:
      return {
        ...state,
        showToaster: false,
      };

    default:
      return state;
  }
};

export default subscribeReducer;
